import React, { useContext, useEffect, useRef, useState } from "react";
import { CsrfContext } from "../context/CsrfContext";
import { FetchPost } from "../utils/fetch";
import { LoadState } from "../utils/LoadState";

interface ActivateStepProps {
    goNextStep: () => void
    goBack: () => void
    userId: string
}

const ActivateStep: React.FC<ActivateStepProps> = ({ goNextStep, goBack, userId }) => {
    const [state, setState] = useState<LoadState>(LoadState.Loading);
    const [redirectLoginPath, setRedirectLoginPath] = useState<string>("");
    const [token, setToken] = useState<string>("");
    const csrfContext = useContext(CsrfContext);

    useEffect(() => {
        FetchPost(csrfContext.csrfToken, "activate", { 'userId': userId },
            (json: any) => {
                setState(json.ok ? LoadState.Success : LoadState.Fail);
                setRedirectLoginPath(json.redirectLoginPath);
                setToken(json.token);
            },
            (err: any) => {
                setState(LoadState.Fail);
            }
        );
    }, [csrfContext, userId]);

    const formRef = useRef<HTMLFormElement>(null);
    useEffect(() => {
        try {
            if (formRef.current) {
                formRef.current.submit();
            }
        } catch (error) {
            console.error('Form submission failed:', error);
        }
    }, [token]);

    switch (state) {
        case LoadState.Success:
            return (
                <div>
                    <p>Вы перенаправлены на форму регистрации...</p>
                    <form ref={formRef} method="POST" action={redirectLoginPath}>
                        <input
                            type="hidden"
                            name="OneTimeTokenId"
                            value={token}
                        />
                    </form>
                </div>
            );
        case LoadState.Fail:
            return <div>
                <p>Ошибка активации id:{userId}</p>
                <button onClick={() => goBack()}>Вернуться к регистрации</button>
            </div>;
        case LoadState.Loading:
        default:
            return <div>
                <p>Попытка активации id:{userId}</p>
            </div>;
    }
}

export default ActivateStep;